export enum JobSituation {
  employedUnavailable,
  employedAvailable,
  unemployedAvailable,
  doNotShow
}
